export class FiltersAttributes {
  filterType: string;
  filterData: any[];
  isActive: boolean;
}


export class FilterDataAttributes {
  name: string;
  status: boolean;
}
export class NavbarFiltersAttributes {
  name: string;
  typeOfFilter: any;
  category: string;
  navName: string;
}

export class filterTypesAttributes {
  // public brand: any[] = [];
  // public frameShape: any[] = [];
  // public frameSize: any[] = [];
  // public gender: any[] = [];
  // public material: any[] = [];
  // public style: any[] = [];
  // public categoryName: any[] = [];
  public startPrice: number = 0;
  public endPrice: number = 0;
  public FromRangeDis: number = 0;
  public ToRangeDis: number = 0;
  public asc: boolean = false;
  public desc: boolean = false;
  public stock: boolean = false;
  public new: boolean = false;
  public itemCode: string ;
  public image: boolean = false;
  public bestSeller: boolean;
  public ProductFilterData : any[] = []
}

export class AppliedFilters {
   public Name : string;
   public Value : any[] = [];
}

export class ProductCatalogueAttributes {
  public actualProductQty: number;
  public totalDiscount : any;
  public Stock : any;
  public batchNumber: string;
  public brandCode: string;
  public brandName: string;
  public categoryCode: string;
  public categoryName: string;
  public discountStatusVO: DiscountAttributes =  new DiscountAttributes();
  public mainImageUrl: string;
  public distributorName: string;
  public distributorStockDetailsId: number;
  public distributorStockId: number;
  public frameShapeCode: string;
  public frameShapeName: string;
  public frameSizeCode: string;
  public frameSizeName: string;
  public genderCode: 'NA';
  public genderName: string;
  public itemCode: string;
  public itemDescription: string;
  public ImagePath: string;
  public ProductDesc: string;
  public BrandName: string;
  public ClusterName: string;
  public Gender: string;
  public Category: string;
  public StrapType: string;
  public Shape: string;
  public Price: number;
  public BaseMat: string;
  public ClaspType: string;
  public Function: string;
  public DialColor: string;
  public StrapColor: string;
  public DressCode: string;
  public Color: string;
  public Material: string;
  public MaterialBody: string;
  public ProductCode: string;
  public ProductType: string;
  public BagType: string;
  public NetContent: string;
  public Fragrance: string;
  public Family: string;
  public Inclusion: string;
  public Collection: string;
  public Perfumer: string;
  public Qty: string;
  public MRP: string;
  public Discount: string;
  public Buckle: string;
  public itemId: number
  public itemImages: any[];
  public ProdImage: any;
  public PMRCatalogue: string;
  public ProdImage1: any;
  public itemPrice: number
  public itemVO: any;
  public discountedPrice: any;
  public materialType: string;
  public netvalue: any;
  public priceId: number;
  public priceVO: any;
  public styleCode: string;
  public styleName: string;
  public transactionalProductQty: number;
  public SKUType: string;
}

export class DiscountAttributes {
  public activationDiscountPercentage: any;
  public activationDiscountPrice: any;
  public tradeDiscountPercentage: any;
  public tradeDiscountPrice: any;
  public priceGroupDiscountPercentage: any;
  public priceGroupDiscountPrice: any;
  public discountPercentage: any;
  public discountedPrice: any;

}
